import _, { isEmpty } from "lodash";
import React, { createContext, useCallback, useEffect, useState } from "react";
import { FiTrash2 } from "react-icons/fi";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { effciencyApi } from "../../../../app/services/efficiencyApi.js";
import { updateSelectedApp } from "../../../../Modules/configuration/HomeSlice.js";

import { Col, Row } from "react-bootstrap";
import ButtonComponent from "../../../../app/common-components/ButtonComponent.jsx";
import CustomModal from "../../../../app/common-components/CustomModal.jsx";
import CustomOffCanvas from "../../../../app/common-components/CustomOffCanvas.jsx";
import CustomSelectDropDown from "../../../../app/common-components/CustomSelectDropDown.jsx";
import DiscardChanges from "../../../../app/common-components/DiscardChanges.jsx";
import Spinners from "../../../../app/common-components/Spinner.jsx";
import CompleteTableData from "../../../../app/common-components/Table/CompleteTableData.jsx";
import { hideOffCanvas, setIsOffCanvasOpen } from "../../../../app/commonSlice.js";
import { useCommonAlert } from "../../../../app/utilities/helpers.js";
import { deviceList } from "../cmdb-overview/appConfigSlice";
import "../styles.scss";

export const ProjectContext = createContext();
const Server = (props) => {
  console.log("yess");
  const dispatch = useDispatch();
  const { callCommonAlert, hideCommonAlert } = useCommonAlert();
  const {
    deviceListData,
    deviceListLoading,
  } = useSelector((state) => state.appConfig);
  const [isLoading, setIsLoading] = useState(false);

  const [pageNo, setpageNo] = useState(0);
  const [pageLimit, setpageLimit] = useState(10);
  const [searchKey, setsearchKey] = useState("");
  const calculatedPageCount = deviceListData?.totalCount
    ? Math.ceil(deviceListData?.totalCount / pageLimit)
    : 0;
  const finalPageCount = calculatedPageCount !== 0 ? calculatedPageCount : 1;
  const { userName } = useSelector((state) => state.common.loggedUser);
  const [showServerForm, setShowServerForm] = useState(false);
  const [showServerAddBtn, setShowServerAddBtn] = useState(true);
  const { efficiency } = useSelector((state) => state);
  const [showServerAlias, setShowServerAlias] = useState("");
  const [showHost, setHost] = useState("");
  const [showIp, setIp] = useState("");
  const [showOs, setOs] = useState("");
  const [showEnvironment, setEnvironment] = useState("");
  const [showtype, settype] = useState("");
  const [getId, setGetId] = useState("");
  const [getType, setGetType] = useState("");
  const { serverLoadPage } = useSelector((state) => state.configuration);
  const [Serverstate, setServerstate] = useState({
    applicationConfig: false,
    appConfigTitle: "",
    cmdbId: "",
    serverList: {},
  });
  // const [projectState, setProjectState] = useState({
  const [serverDeleteoad, setServerDeleteoad] = useState(false);
  const [state, setState] = useState({
    page: 0,
    limit: 10,
    tableData: [],
    count: 0,
    importModal: false,
    newApplication: false,
    projectId: "",
    file: "",
    fileInfo: "",
    deleteModalOpen: false,
    loadPage: false,
    modalOpen: false,
    loading: false,
    deleteId: "",
    DeviceError: false,
    DeviceErrorMessage: "",
    addBodyServers: false,
    conformationPop: false,
  });
  const serverListData = state.tableData;

  const location = useLocation();
  const { state: locationState } = useLocation();

  const payloadid = locationState?.id;
  const applicationName = locationState?.appName;
  const isNavigated = _.get(location, "state.isNavigated", false);
  useEffect(() => {
    if (locationState && locationState.appLabel) {
      const homeNavApp = {
        label: `${locationState.appLabel}[${locationState.appCode}]`,
        value: locationState.appCode,
        id: locationState.id,
      };
      dispatch(updateSelectedApp(homeNavApp));
    } else {
      dispatch(updateSelectedApp({}));
    }
  }, [dispatch]);
  const payload = {
    keyword: searchKey,
  };
  const navigate = useNavigate();
  // const [getServerList] = effciencyApi.useGetServerListMutation();
  const [getServerdelete] = effciencyApi.useGetServerdeleteMutation();
  const [getServerSave] = effciencyApi.useGetServerSaveMutation();
  const [getCheckIP] = effciencyApi.useGetCheckIPMutation();
  const [getCheckServerName] = effciencyApi.useGetCheckServerNameMutation();
  // const [getServerCount] = effciencyApi.useGetServerCountMutation();
  const [getAllServerConfigInfo] =
    effciencyApi.useGetAllServerConfigInfoMutation();

  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const [currentAction, setCurrentAction] = useState("");

  const [search, setSearch] = useState([]);
  const [deviceNameData, setDeviceNameData] = useState([]);
  const [deviceNameOption, setDeviceNameOption] = useState([]);
  let serverData = "";

  serverData = serverListData.data?.map((server) => ({
    deviceName: server.deviceName,
    host: server.hostName,
    IP: server.ip,
    operationSystem: server.operationSystem,
    environment: server.environment,
    id: server.id,
    type: server.type,
  }));

  const callDevice = () => {
    getAllServerConfigInfo({ cmdbId: payloadid })
      .unwrap()
      .then((res) => {
        setDeviceNameData(res?.data ?? res ?? []);
      });
  };
  const clickbtn = () => {
    clearValidation();
    setState((state) => ({
      ...state,
      conformationPop: false,
    }));
    return openserver("add", 0);
  };

  useEffect(() => {
    const keysArray = deviceNameData.map((ids, index) => ({
      label: ids.deviceName,
      value: ids.deviceName,
    }));
    setDeviceNameOption(keysArray);
  }, [deviceNameData]);
  const Btnadd = [
    {
      text: "Map New",
      function: clickbtn,
      className: "solid-btn",
    },
  ];

  const columns = [
    {
      Header: "Device Name",
      accessor: "deviceName",
    },
    {
      Header: "Type",
      accessor: "type",
    },
    {
      Header: "Hostname",
      accessor: "hostName",
    },
    {
      Header: "Operating System",
      accessor: "operationSystem",
    },
    {
      Header: "IP",
      accessor: "ip",
    },
    {
      Header: "Environment",
      accessor: "environment",
    },
    {
      Header: "Last Fetched for VM",
      accessor: "lastFetchedDateForVulnerability",
      thClassName: "wrap_class",
      tdClassName: "text-center",
      Cell: ({ value }) => {
        return <>{value ? value : "-"}</>;
      },
    },
    {
      Header: "Last Scanned for VM",
      accessor: "lastScannedDateForVulnerability",
      thClassName: "wrap_class",
      tdClassName: "text-center",
      Cell: ({ value }) => {
        return <>{value ? value : "-"}</>;
      },
    },
    {
      Header: "Last Fetched for CIS",
      accessor: "lastFetchedDateForCISBenchMark",
      thClassName: "wrap_class",
      tdClassName: "text-center",
      Cell: ({ value }) => {
        return <>{value ? value : "-"}</>;
      },
    },
    {
      Header: "Last Scanned for CIS",
      accessor: "lastScannedDateForCISBenchMark",
      thClassName: "wrap_class",
      tdClassName: "text-center",
      Cell: ({ value }) => {
        return <>{value ? value : "-"}</>;
      },
    },
    {
      Header: "Action",
      accessor: "Action",
      tdClassName: "text-center",
      className: "text-center",
      disableSortBy: true,
      thClassName: "text-center",
      Cell: ({ row }) => (
        <div>
          {" "}
          <div className="actcol">
            <FiTrash2
              title="Delete"
              className="iconStyleActions"
              onClick={() => {
                callDelete(row.original.id);
              }}
            />
          </div>
        </div>
      ),
    },
  ];
  const btnData = [
    {
      text: "Map New",
      function: clickbtn,
      className: "solid-btn",
    },
  ];
  const callDelete = (id) => {
    setState((state) => ({
      ...state,
      modalOpen: true,
      deleteId: id,
    }));
  };
  const getdeviceInfo = () => {
    const appCode = locationState?.appCode;
    dispatch(
      deviceList({
        cmdbId: payloadid,
        pageNumber: pageNo,
        itemsPerPage: pageLimit,
        payload,
      })
    );
  };

  useEffect(() => {
    getdeviceInfo();
  }, [pageNo, pageLimit, searchKey]);
  const openserver = async (action, id) => {
    callDevice();
    clearValidation();
    if (action == "edit") {
      const filteredServers = serverListData
        .map((server) => ({
          deviceName: server.deviceName,
          host: server.host,
          operationSystem: server.operationSystem,
          IP: server.IP,
          environment: server.environment,
          id: server.id,
          type: server.type,
        }))
        .filter((server) => server.id === id);
      setShowServerAlias(filteredServers.map((data) => data.deviceName));
      settype(filteredServers.map((data) => data.type).join(","));
      setHost(filteredServers.map((data) => data.host).join(","));
      setIp(filteredServers.map((data) => data.IP).join(","));
      setOs(filteredServers.map((data) => data.operationSystem).join(","));
      setEnvironment(filteredServers.map((data) => data.environment).join(","));
      setGetId(filteredServers.map((data) => data.id).join(","));
      setGetType(filteredServers.map((data) => data.type).join(","));
      setCurrentAction("edit");
      setIsSidebarOpen(true);
    } else {
      settype("");
      setShowServerAlias("");
      setHost("");
      setOs("");
      setIp("");
      setEnvironment("");
      setCurrentAction("add");
      setState((state) => ({
        ...state,
        type: "",
      }));
    }
    dispatch(
      setIsOffCanvasOpen({
        isDrilldownOpen: true,
        isDropDownhide: true,
      })
    );
    // setShowServerForm(true)
    // setShowServerAddBtn(false)
  };

  const validateForm = () => {
    let formValidation = true;
    if (showServerAlias === "") {
      setState((state) => ({
        ...state,
        DeviceError: true,
        DeviceErrorMessage: "Device Name should not be empty",
      }));
      formValidation = false;
    }
    return formValidation;
  };
  const clearValidation = () => {
    setState((state) => ({
      ...state,
      DeviceError: false,
      DeviceErrorMessage: "",
    }));
  };
  const handleOnChange = (name, selectedValue) => {
    console.log(name, selectedValue);
    let value = selectedValue;
    setState((state) => ({
      ...state,
      DeviceError: false,
      DeviceErrorMessage: "",
      conformationPop: true,
    }));
    value = isEmpty(selectedValue) ? "" : [selectedValue];
    if (name == "Device Name") {
      const foundDevice = value
        ? deviceNameData.find((device) => device.deviceName === value[0].value)
        : "";
      setState((prevState) => ({
        ...prevState,
        type: foundDevice ? foundDevice.type : "",
      }));
      setShowServerAlias(foundDevice ? foundDevice.deviceName : "");
      setHost(foundDevice ? foundDevice.hostName : "");
      setOs(foundDevice ? foundDevice.operatingSystem : "");
      setIp(foundDevice ? foundDevice.ip : "");
      setEnvironment(foundDevice ? foundDevice.environment : "");
      setGetId(foundDevice ? foundDevice.id : "");
    }
  };

  const handleSaveAdd = () => {
    const validation = validateForm();
    if (validation) {
      let cmdbId = payloadid;
      let id = 0;
      let Environment = showEnvironment;
      let Host = showHost;
      let Ip = showIp;
      let deviceName = showServerAlias;
      let operationSystem = showOs;
      const payload = {
        appCode: "",
        appName: "",
        createBy: "",
        createdDt: "",
        environment: Environment,
        hostName: Host,
        type: state.type,
        id: id,
        ip: Ip,
        deviceName: deviceName,
        updateBy: "",
        updateDt: "",
        operationSystem: operationSystem,
      };
      setIsLoading(true);
      getServerSave({ cmdbId, payload, userName })
        .then((data) => {
          console.log("data", data);
          setIsLoading(false);
          if (data?.data?.statusCodeValue === 200) {
            console.log("happen200");
            addserverclose();
            getdeviceInfo();
            callCommonAlert(
              "success",
              _.get(data, "data.body")
                ? data?.data?.body
                : "Device Configuration saved successfully"
            );
            setState((state) => ({
              ...state,
              modalOpen: false,
            }));
            hideCommonAlert();
          } else if (data?.data?.statusCodeValue === 400) {
            console.log("happen400");

            callCommonAlert(
              "error",
              _.get(data, "data.body")
                ? data?.data?.body
                : "Something went wrong please try again."
            );
            hideCommonAlert();

          } else if (data?.error) {
            callCommonAlert(
              "error",
              "Error occurred while adding Device. Please try again."
            );
          }
        });
    }
  };
  const submitSave = useCallback(async () => {
    if (currentAction === "edit") {
      handleSaveEdit();
    } else {
      handleSaveAdd();
    }
  });

  const addserverclose = async () => {
    dispatch(hideOffCanvas(false));
    setShowServerForm(false);
    setShowServerAddBtn(true);
    setIsSidebarOpen(false);
    resetInput("");
    clearValidation();
    addBodyCloseServers();
    setState((state) => ({
      ...state,
      conformationPop: false,
    }));
  };
  const onDeleteData = (data) => {
    setState((state) => ({
      ...state,
      projectId: data.id,
      deleteModalOpen: false,
    }));
  };

  const deleteId = () => {
    getServerdelete({ id: state.deleteId, userName: userName })
      .unwrap(setServerDeleteoad(true))
      .then((data) => {
        setServerDeleteoad(false);
        if (data?.statusCodeValue === 200) {
          setpageNo(0);
          setsearchKey("");
          getdeviceInfo();
          callCommonAlert(
            "success",
            _.get(data, "body")
              ? data?.body
              : "Device Configuration deleted successfully"
          );
          setState((state) => ({
            ...state,
            modalOpen: false,
          }));
          hideCommonAlert();
        } else if (data?.statusCodeValue === 400) {
          getdeviceInfo();
          callCommonAlert(
            "error",
            _.get(data, "body")
              ? data?.body
              : "Something went wrong please try again."
          );
          hideCommonAlert();
        }
      });
  };

  const adminActTools = [
    {
      label: "Jira",
      value: "jira",
    },
    {
      label: "Jenkins",
      value: "jenkins",
    },
    {
      label: "Confluence",
      value: "confluence",
    },
    {
      label: "Bitbucket",
      value: "bitbucket",
    },
  ];

  const ServerListDataList = () => (
    <datalist id="serverlistdatalist">
      {adminActTools.map((adminActTools) => (
        <option key={adminActTools.value} value={adminActTools.value} />
      ))}
    </datalist>
  );
  const modalBody = () => (
    <>
      <h4 className="delete-h"> Unmap Device Configuration</h4>
      {serverDeleteoad ? (
        <Spinners />
      ) : (
        <div>
          <p>
            Are you sure you want to unmap this Device from the Application?
          </p>{" "}
          <div className="btnswrap btn-dlt">
            <ButtonComponent
              text="Cancel"
              className={"cancelBtnStyle btn btn-primary"}
              onClick={handleClose}
            />
            <ButtonComponent
              text="Confirm"
              className={"btnStyle btn btn-primary"}
              onClick={deleteId}
            />
          </div>
        </div>
      )}
    </>
  );
  const handleClose = () => {
    setState({
      ...state,
      modalOpen: false,
    });
    hideCommonAlert();
  };
  const addmodalCancelServers = () => {
    setState((state) => ({
      ...state,
      addBodyServers: true,
    }));
  };
  const addBodyCloseServers = () => {
    setState({
      ...state,
      addBodyServers: false,
    });
  };
  const addBodyCancelServers = () => {
    return (
      <>
        <DiscardChanges
          title={"add"}
          discardClick={addserverclose}
          cancelClick={addBodyCloseServers}
        />
      </>
    );
  };

  const isDisabled = () => {
    if (
      !showServerAlias ||
      !showHost ||
      !showOs ||
      !showIp ||
      !showEnvironment
    ) {
      return true;
    }
    return false;
  };

  const resetInput = () => {
    setShowServerAlias("");
    setHost("");
    setIp("");
    setOs("");
    setEnvironment("");
    setGetId("");
    setState((state) => ({
      ...state,
      type: "",
    }));
  };
  const options = [
    { value: "Network", label: "Network" },
    { value: "FireWall", label: "FireWall" },
    { value: "Server", label: "Server" },
  ];

  let totalPages = Math.ceil(state.count / state.limit);
  const handleSearch = (searchString, IterationList) => {
    if (Array.isArray(deviceNameOption)) {
      const matchedUsers = IterationList.filter((item) =>
        item.label.toLowerCase().includes(searchString.toLowerCase())
      );
      setSearch(matchedUsers);
    } else {
      setSearch([]);
    }
  };
  function getLimit(limit) {
    setpageLimit(limit);
    setpageNo(0);
  }
  function getPage(pageNo) {
    setpageNo(pageNo);
  }
  function getSearchKey(key) {
    setpageNo(0);
    setpageLimit(10);
    setsearchKey(key);
  }
  return (
    <div>
      <ProjectContext.Provider value={{ state, setState }}>
        <CustomModal
          modalOpen={state.modalOpen}
          modalBody={modalBody}
          modalTitle={"Delete Configuration"}
          closeBtn={false}
          closeBtnFuc={handleClose}
        />
        <CustomModal
          modalOpen={state.addBodyServers}
          modalBody={addBodyCancelServers}
          modalHide={addmodalCancelServers}
          closeBtn={true}
          closeBtnFuc={addBodyCloseServers}
        />
        {/* <DrillDownOffCanvas
          customClass={"flowblock toolwrap custom_scroll"}
          subHeading={"Please enter your Project data."}
        /> */}
      </ProjectContext.Provider>
      <div className="p-0-5">
        <div>
          <div
            style={{
              marginRight: showServerForm ? "75%" : "0",
              width: showServerForm ? "75%" : "100%",
            }}
          >
            <div className="grid-table">
              <CompleteTableData
                isLoading={deviceListLoading}
                data={deviceListData?.data || []}
                columns={columns}
                onPageLimitChange={getLimit}
                onPageNoChange={getPage}
                onSearch={getSearchKey}
                curentPageNumber={pageNo}
                pageLimit={pageLimit}
                searchKey={searchKey}
                totalPageCount={finalPageCount}
                listCount={deviceListData?.totalCount}
                btnData={btnData}
                moveSearchToEnd={true}
              />
            </div>
          </div>
          <CustomOffCanvas className="custom-off-canvas">
            <h3
              className="flowhead"
              id="updatehead"
              style={{ display: "block" }}
            >
              {currentAction === "edit"
                ? "Update Device"
                : "Map New Device"}{" "}
            </h3>
            {isLoading ? (
              <Spinners />
            ) : (
              <>
                <Row className="appConfigAddNew m-0">
                  <Col>
                    <div className="mb-3">
                      <label className="form-label">Device Name<span className="RedHighlight">*</span></label>
                      <CustomSelectDropDown
                        label={"Device Name*"}
                        name={"Device Name"}
                        id="device"
                        options={deviceNameOption}
                        value={showServerAlias}
                        customClassName="notFocus"
                        onSearch={(searchString) =>
                          handleSearch(searchString, deviceNameOption)
                        }
                        containerClassName={"frmgroup validate"}
                        selected={deviceNameOption}
                        onChange={(selected) =>
                          handleOnChange("Device Name", selected)
                        }
                        placeholder={"Enter Device Name"}
                        error={state["DeviceError"]}
                        errorMessage={state["DeviceErrorMessage"]}
                      />
                    </div>
                  </Col>
                  <Col className="">
                    <div className="mb-3">
                      <label className="form-label">Type</label>
                      <input
                        type="text"
                        list="serverlistdatalist"
                        name={"type"}
                        id="type"
                        className="form-control"
                        value={
                          currentAction === "edit"
                            ? getType
                            : state.type
                              ? state.type
                              : ""
                        }
                        maxLength="50"
                        isDisabled={true}
                        disabled
                      />
                    </div>
                  </Col>
                </Row>
                <Row className="appConfigAddNew m-0">
                  <Col>
                    <div className="mb-3">
                      <label className="form-label">Hostname</label>
                      <input
                        type="text"
                        list="serverlistdatalist"
                        name={"host"}
                        id="host"
                        className="form-control"
                        placeholder={"Enter Hostname"}
                        value={showHost}
                        maxLength="50"
                        isDisabled={true}
                        disabled
                      />
                      {/* <ServerListDataList /> */}
                    </div>
                  </Col>
                  <Col>
                    <div className="mb-3">
                      <label className="form-label">Operating System</label>
                      <input
                        type="text"
                        list="serverlistdatalist"
                        name={"os"}
                        id="os"
                        className="form-control"
                        // placeholder="Enter Operating System"
                        value={showOs}
                        isDisabled={true}
                        //onChange={(e) => setOs(e.target.value)}
                        maxLength="50"
                        disabled
                      />
                      {/* <ServerListDataList /> */}
                    </div>
                  </Col>
                </Row>
                <Row className="appConfigAddNew m-0">
                  <Col>
                    <div className="mb-3">
                      <label className="form-label">IP</label>
                      <input
                        type="text"
                        list="serverlistdatalist"
                        name="ip"
                        id="ip"
                        className="form-control"
                        // placeholder="Enter IP"
                        value={showIp}
                        isDisabled={true}
                        disabled
                        // onChange={(e) => setIp(e.target.value)}
                        // onKeyPress={(e) => {
                        //   const pattern = /^[0-9.]+$/;
                        //   if (!pattern.test(e.key)) {
                        //     e.preventDefault();
                        //   }
                        // }}
                        maxLength="15"
                      />
                      {/* <ServerListDataList /> */}
                    </div>
                  </Col>
                  <Col>
                    <div className="mb-3">
                      <label className="form-label">Environment</label>
                      <input
                        type="text"
                        list="serverlistdatalist"
                        name={"environment"}
                        id="environment"
                        className="form-control"
                        // placeholder="Enter Environment"
                        value={showEnvironment}
                        isDisabled={true}
                        disabled
                        // onChange={(e) => setEnvironment(e.target.value)}
                        maxLength="50"
                      />
                      {/* <ServerListDataList /> */}
                      <input
                        type="hidden"
                        name={"id"}
                        id="id"
                        className="form-control"
                        //placeholder="id"
                        value={getId}
                        isDisabled={true}
                        disabled
                        // onChange={(e) => setGetId(e.target.value)}
                        maxLength="50"
                      />
                    </div>
                  </Col>
                </Row>
                <Row className="m-0">
                  <Col></Col>
                  <Col>
                    <div
                      className="server-btn"
                      style={{ display: "block", justifyContent: "end" }}
                    >
                      <ButtonComponent
                        className="cancelBtnStyle"
                        text="Cancel"
                        onClick={() => {
                          if (state.conformationPop) {
                            addmodalCancelServers();
                          } else {
                            addserverclose();
                          }
                        }}
                      />
                      <ButtonComponent
                        class="btnStyle"
                        onClick={submitSave}
                        text="Save"
                      />
                      {/* )} */}
                    </div>
                  </Col>
                </Row>
              </>
            )}
          </CustomOffCanvas>
        </div>
      </div>
    </div>
  );
};

export default Server;
